//----------------------------------------------------
// DownloadPDFButton.jsx
// Logboek24 – PDF downloaden met voortgangsbalk
//----------------------------------------------------
import React, { useState } from "react";
import { getAccessToken } from "../utils/authStorage";
import { apiUrl } from "../config/api";

export default function DownloadPDFButton({ entryId }) {
  const [progress, setProgress] = useState(0);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (!entryId) {
      alert("Geen logboek-ID opgegeven.");
      return;
    }

    setProgress(0);
    setDownloading(true);

    try {
      const token = getAccessToken();
      const response = await fetch(apiUrl(`/logbook/pdf/${entryId}`), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Fout bij downloaden PDF");
      }

      // 🧠 Gebruik streaming om downloadvoortgang te meten
      const contentLength = response.headers.get("Content-Length");
      const total = contentLength ? parseInt(contentLength, 10) : 0;
      const reader = response.body.getReader();
      let received = 0;
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        if (total) {
          setProgress(Math.round((received / total) * 100));
        }
      }

      const blob = new Blob(chunks, { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `logboek_${entryId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setProgress(100);
      setTimeout(() => setDownloading(false), 1000);
    } catch (err) {
      console.error("❌ Fout bij downloaden PDF:", err);
      alert("Er is iets misgegaan bij het downloaden van de PDF.");
      setDownloading(false);
    }
  };

  return (
    <div className="w-full max-w-sm">
      <button
        onClick={handleDownload}
        disabled={downloading}
        className={`flex items-center gap-2 w-full justify-center bg-red-600 text-white font-medium px-4 py-2 rounded-lg shadow-md transition-all 
        ${downloading ? "opacity-70 cursor-not-allowed" : "hover:bg-red-700"}`}
      >
        {downloading ? (
          <>
            <span role="img" aria-label="pdf">📄</span>
            Downloaden...
          </>
        ) : (
          <>
            <span role="img" aria-label="pdf">📄</span>
            Download PDF
          </>
        )}
      </button>

      {downloading && (
        <div className="mt-3 w-full bg-gray-200 rounded-full h-3 overflow-hidden shadow-inner">
          <div
            className="bg-red-600 h-3 transition-all duration-200 ease-linear"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      )}

      {downloading && (
        <p className="text-sm text-gray-600 mt-1 text-center">
          {progress < 100 ? `Download voortgang: ${progress}%` : "Download voltooid"}
        </p>
      )}
    </div>
  );
}
